import { render, staticRenderFns } from "./AddDashboardButton.vue?vue&type=template&id=479ac370&"
import script from "./AddDashboardButton.vue?vue&type=script&lang=js&"
export * from "./AddDashboardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports